export default {
  fetchProtocolProgressionTodoList: {
    api: {
      url: 'default',
      version: '2',
    },
    $$method: 'get',
    $$config: {
      headers: (data) => data.headers.authorization,
    },
    $$meta: {
      mock: () => 'mocks/endpoints/todoList/fetchProtocolProgressionTodoList.json',
    },
    $$makeUrl(configs, { offset, limit }) {
      // TODO: changes this or we are going to have problems... :hammer:
      const url = `therapist/v${configs.api.version}/protocol_prescriptions/todo`
      const queryParams = new URLSearchParams('')

      if (offset !== undefined) {
        queryParams.append('offset', offset)
      }
      if (limit) {
        queryParams.append('limit', limit)
      }

      queryParams.append('includes', ['skipped_exercises', 'summary', 'last_session_results', 'changes'].join(','))

      return `${url}?${queryParams}`
    },
  },
  fetchPendingPrescriptionsTodoList: {
    api: {
      url: 'default',
      version: '1',
    },
    $$method: 'get',
    $$config: {
      headers: (data) => data.headers.authorization,
    },
    $$meta: {
      mock: () => 'mocks/endpoints/todoList/fetchPendingPrescriptionsTodoList.json',
    },
    $$makeUrl(configs, { offset, limit }) {
      const url = `therapist/v${configs.api.version}/pending-prescriptions/todo`
      const queryParams = new URLSearchParams('')

      if (offset !== undefined) {
        queryParams.append('offset', offset)
      }
      if (limit) {
        queryParams.append('limit', limit)
      }

      return `${url}?${queryParams}`
    },
  },
  fetchPendingExclusionRequests: {
    api: {
      url: 'default',
      version: '1',
    },
    $$method: 'get',
    $$config: {
      headers: (data) => data.headers.authorization,
    },
    $$meta: {
      mock: () => 'mocks/endpoints/todoList/fetchPendingExclusionRequestsTodoLists.json',
    },
    $$makeUrl(configs, { offset, limit, leadRequest }) {
      const url = `therapist/v${configs.api.version}/exclusion-requests/todo`
      const queryParams = new URLSearchParams('')

      queryParams.append('status', 'pending')

      if (offset !== undefined) {
        queryParams.append('offset', offset)
      }
      if (limit) {
        queryParams.append('limit', limit)
      }
      if (leadRequest) {
        queryParams.append('lead_request', true)
      }

      queryParams.append('includes', ['patient_info', 'professional_info'].join(','))

      return `${url}?${queryParams}`
    },
  },
  fetchReachOutTodos: {
    api: {
      url: 'default',
      version: '1',
    },
    $$method: 'get',
    $$config: {
      headers: (data) => data.headers.authorization,
    },
    $$meta: {
      mock: () => 'mocks/endpoints/todoList/fetchPendingExclusionRequestsTodoLists.json',
    },
    $$makeUrl(configs, { offset, limit }) {
      const url = `therapist/v${configs.api.version}/dynamic-reach-outs`
      const queryParams = new URLSearchParams('')

      if (offset || offset === 0) {
        queryParams.append('offset', offset)
      }
      if (limit) {
        queryParams.append('limit', limit)
      }

      return `${url}?${queryParams}`
    },
  },
  updateReachOutStatus: {
    api: {
      url: 'default',
      version: '1',
    },
    $$method: 'put',
    $$config: {
      headers: (data) => data.headers.authorization,
    },
    $$makeUrl(configs, reachOutUuid) {
      return `therapist/v${configs.api.version}/dynamic-reach-outs/${reachOutUuid}`
    },
  },
  updateReachOutAutoSuggestedMessage: {
    api: {
      url: 'default',
      version: '1',
    },
    $$method: 'post',
    $$config: {
      headers: (data) => data.headers.authorization,
    },
    $$makeUrl(configs, reachOutUuid) {
      return `therapist/v${configs.api.version}/dynamic-reach-outs/${reachOutUuid}/auto-suggested-message`
    },
  },
  fetchPendingPlanOfCareTodos: {
    api: {
      url: 'default',
      version: '1',
    },
    $$method: 'get',
    $$config: {
      headers: (data) => data.headers.authorization,
    },
    $$meta: {
      mock: () => 'mocks/endpoints/todoList/fetchPendingPlanOfCareTodoLists.json',
    },
    $$makeUrl(configs, { offset, limit }) {
      const url = `therapist/v${configs.api.version}/pending-plan-of-care-notes`
      const queryParams = new URLSearchParams('')

      if (offset || offset === 0) {
        queryParams.append('offset', offset)
      }
      if (limit) {
        queryParams.append('limit', limit)
      }

      return `${url}?${queryParams}`
    },
  },
  updatePendingPlanOfCareNote: {
    api: {
      url: 'default',
      version: '1',
    },
    $$method: 'put',
    $$config: {
      headers: (data) => data.headers.authorization,
    },
    $$makeUrl(configs, pendingPlanOfCareUuid) {
      return `therapist/v${configs.api.version}/pending-plan-of-care-notes/${pendingPlanOfCareUuid}`
    },
  },
  updateExclusionRequestStatus: {
    api: {
      url: 'default',
      version: '1',
    },
    $$method: 'post',
    $$config: {
      headers: (data) => data.headers.authorization,
    },
    $$makeUrl(configs, { id, status }) {
      return `therapist/v${configs.api.version}/exclusion-requests/${id}/status/${status}`
    },
  },
  fetchProblematicSessionsTodoList: {
    api: {
      url: 'default',
      version: '1',
    },
    $$method: 'get',
    $$config: {
      headers: (data) => data.headers.authorization,
    },
    $$meta: {
      mock: () => 'mocks/endpoints/todoList/fetchProblematicSessionsTodoList.json',
    },
    $$makeUrl(configs, { offset, limit }) {
      const url = `therapist/v${configs.api.version}/problematic-sessions`
      const queryParams = new URLSearchParams('')

      if (offset !== undefined) {
        queryParams.append('offset', offset)
      }
      if (limit) {
        queryParams.append('limit', limit)
      }

      return `${url}?${queryParams}`
    },

  },
  fetchClinicalProblematicSessionsTodoList: {
    api: {
      url: 'default',
      version: '1',
    },
    $$method: 'get',
    $$config: {
      headers: (data) => data.headers.authorization,
    },
    $$meta: {
      mock: () => 'mocks/endpoints/todoList/fetchProblematicSessionsBloomTodoList.json',
    },
    $$makeUrl(configs, { offset, limit }) {
      const url = `therapist/v${configs.api.version}/bloom/problematic-sessions`
      const queryParams = new URLSearchParams('')

      if (offset !== undefined) {
        queryParams.append('offset', offset)
      }
      if (limit) {
        queryParams.append('limit', limit)
      }

      return `${url}?${queryParams}`
    },

  },
  acknowledgeProblematicSessionBloom: {
    api: {
      url: 'default',
      version: '1',
    },
    $$method: 'post',
    $$config: {
      headers: (data) => data.headers.authorization,
    },
    /*  $$meta: {
      mock: () => 'mocks/endpoints/requestResponses/emptyHit.json',
    }, */
    $$makeUrl(configs) {
      return `therapist/v${configs.api.version}/bloom/problematic-sessions/acknowledge`
    },
  },
  acknowledgeProblematicSession: {
    api: {
      url: 'default',
      version: '1',
    },
    $$method: 'post',
    $$config: {
      headers: (data) => data.headers.authorization,
    },
    $$meta: {
      mock: () => 'mocks/endpoints/requestResponses/emptyHit.json',
    },
    $$makeUrl(configs) {
      return `therapist/v${configs.api.version}/problematic-sessions-actions/acknowledge`
    },
  },
  fetchProblematicSessionDetails: {
    api: {
      url: 'default',
      version: '1',
    },
    $$method: 'get',
    $$config: {
      headers: (data) => data.headers.authorization,
    },
    $$meta: {
      mock: (_, sessionUuid) => `mocks/endpoints/todoList/fetchProblematicSessionDetails/${sessionUuid}.json`,
    },
    $$makeUrl(configs, sessionUuid) {
      const url = `therapist/v${configs.api.version}/problematic-sessions/details`
      const queryParams = new URLSearchParams('')

      if (sessionUuid) {
        queryParams.append('uuids', sessionUuid)
      }

      return `${url}?${queryParams}`
    },
  },
  fetchProblematicReassessmentsTodoList: {
    api: {
      url: 'default',
      version: '1',
    },
    $$method: 'get',
    $$config: {
      headers: (data) => data.headers.authorization,
    },
    $$meta: {
      mock: () => 'mocks/endpoints/todoList/fetchProblematicReassessmentsTodoList.json',
    },
    $$makeUrl(configs, { offset, limit }) {
      const url = `therapist/v${configs.api.version}/problematic-reassessments`
      const queryParams = new URLSearchParams('')

      if (offset !== undefined) {
        queryParams.append('offset', offset)
      }
      if (limit) {
        queryParams.append('limit', limit)
      }

      return `${url}?${queryParams}`
    },

  },
  acknowledgeProblematicReassessment: {
    api: {
      url: 'default',
      version: '1',
    },
    $$method: 'post',
    $$config: {
      headers: (data) => data.headers.authorization,
    },
    $$meta: {
      mock: () => 'mocks/endpoints/requestResponses/emptyHit.json',
    },
    $$makeUrl(configs) {
      return `therapist/v${configs.api.version}/problematic-reassessments/acknowledge`
    },
  },
  fetchTodoListCounters: {
    api: {
      url: 'default',
      version: '1',
    },
    $$method: 'get',
    $$config: {
      headers: (data) => data.headers.authorization,
    },
    $$meta: {
      mock: () => 'mocks/endpoints/todoList/fetchTodoListCounters.json',
    },
    $$makeUrl(configs, tabs) {
      const url = `therapist/v${configs.api.version}/todo-list/overview`
      const queryParams = new URLSearchParams('')

      if (tabs) {
        queryParams.append('tabs', tabs)
      }

      return `${url}?${queryParams}`
    },
  },
}
